import React, { useEffect } from "react";
import { SalesPage } from "./components/SalesPage";
export function App() {
  useEffect(() => {
    // Evita duplicarlo si recarga
    if ((window as any).fbq) return;

    // Crea el script del pixel
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    // Define fbq
    (window as any).fbq = function () {
      ((window as any).fbq as any).callMethod ? ((window as any).fbq as any).callMethod.apply(null, arguments as any) : ((window as any).fbq as any).queue.push(arguments);
    };
    (window as any)._fbq = (window as any).fbq;
    (window as any).fbq.push = (window as any).fbq;
    (window as any).fbq.loaded = true;
    (window as any).fbq.version = "2.0";
    (window as any).fbq.queue = [];

    // Init + PageView
    (window as any).fbq("init", "1447388003777729");
    (window as any).fbq("track", "PageView");
  }, []);
  return <SalesPage data-id="element-0" />;
}